<template>
  <div class="rec-main">
    <div class="rec-content">
      <!-- 我们这里点击刷新只让我们这个子组件刷新 -->
      <!-- 子组件强制刷欣 会执行他的created方法 就会重新请求数据 -->
      <!-- 太好了这里go（0）  只让我们的这个子组件刷欣 -->
      <ul class="rec-list">
        <!-- <li
          v-for="item in features_list"
          :cookInfo="item"
          :key="item.r.id"
        ></li> -->
        <cook-item
          v-for="item in features_list"
          :cookInfo="item"
          :key="item.r.id"
        >
        </cook-item>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import url from "@/url/url.js";
import { Icon } from "vant";
import cookItem from "./cookItem";

Vue.use(Icon);
export default {
  data() {
    return {
      dataArr: [],
      features_list: [],
    };
  },
  components: {
    cookItem,
  },
  methods: {},
  created() {
    (async () => {
      let res = await this.$http.get(url.homeUrl);

      if ((res.state = "success")) {
        if (res.result) {
          let resArr = res.result.features_list.list;
          resArr.forEach((item) => {
            if (typeof item == "object" && item && !(item instanceof Array)) {
              if (item.r) {
                this.features_list.push(item);
              }
            }
          });
        }
      } else {
        return false;
      }
    })();

    //   (async function () {
    //    let res = await this.$http.get(url.homeUrl)
    //       if ((res.state = "success")) {
    //         if (res.result) {
    //           let resArr = res.result.features_list.list;
    //           resArr.forEach((item) => {
    //             console.log(item);
    //             this.features_list.push(item);
    //           });
    //         }
    //       } else {
    //         return;
    //       }
    //       console.log(this.features_list);
    //   })()
    // );
  },
};
</script>
<style lang="scss" scoped>
</style>